import React from 'react';
import { FormField, inputClass } from './FormField';

const TRIGGERING_CONDITIONS = [
  { value: '', label: 'Select a triggering condition...' },
  { value: 'deportation', label: 'Deportation or Removal Order' },
  { value: 'detention', label: 'Immigration Detention' },
  { value: 'extended_absence', label: 'Extended Absence from the Country' },
  { value: 'incapacitation', label: 'Physical or Mental Incapacitation' },
  { value: 'other', label: 'Other (describe in notes)' },
];

export const StepDuration = ({ formData, onChange, errors }) => {
  const set = (field) => (e) => onChange({ ...formData, [field]: e.target.value });

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold text-brand-navy mb-1">Duration & Conditions</h3>
        <p className="text-sm text-slate-500">Define when this Power of Attorney becomes effective and how long it lasts.</p>
      </div>

      <FormField label="Effective Date" error={errors.effectiveDate} required>
        <input
          type="date"
          className={inputClass(errors.effectiveDate)}
          value={formData.effectiveDate || ''}
          onChange={set('effectiveDate')}
        />
      </FormField>

      <div>
        <label className="block text-sm font-medium text-slate-700 mb-2">
          Expiration <span className="text-red-500">*</span>
        </label>
        <div className="space-y-2">
          {[
            { value: 'revoked', label: 'Until Revoked (no fixed end date)' },
            { value: 'date', label: 'Specific Expiration Date' },
          ].map((opt) => (
            <label key={opt.value} className="flex items-center gap-3 cursor-pointer p-3 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors">
              <input
                type="radio"
                name="expirationOption"
                value={opt.value}
                checked={formData.expirationOption === opt.value}
                onChange={set('expirationOption')}
                className="accent-slate-900"
              />
              <span className="text-sm text-slate-700">{opt.label}</span>
            </label>
          ))}
        </div>
        {errors.expirationOption && <p className="mt-1 text-xs text-red-600">{errors.expirationOption}</p>}
      </div>

      {formData.expirationOption === 'date' && (
        <FormField label="Expiration Date" error={errors.expirationDate} required>
          <input
            type="date"
            className={inputClass(errors.expirationDate)}
            value={formData.expirationDate || ''}
            onChange={set('expirationDate')}
            min={formData.effectiveDate || undefined}
          />
        </FormField>
      )}

      <FormField label="Triggering Condition" error={errors.triggeringCondition} required>
        <select
          className={inputClass(errors.triggeringCondition)}
          value={formData.triggeringCondition || ''}
          onChange={set('triggeringCondition')}
        >
          {TRIGGERING_CONDITIONS.map((c) => (
            <option key={c.value} value={c.value}>{c.label}</option>
          ))}
        </select>
      </FormField>

      {formData.triggeringCondition === 'other' && (
        <FormField label="Describe the Triggering Condition">
          <textarea
            className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-2 focus:ring-slate-900 outline-none resize-none min-h-[80px]"
            value={formData.triggeringConditionNote || ''}
            onChange={(e) => onChange({ ...formData, triggeringConditionNote: e.target.value })}
            placeholder="Please describe the specific condition..."
          />
        </FormField>
      )}
    </div>
  );
};